var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-center align-items-center" },
        [
          _c(
            "div",
            [
              _c(
                "b-button",
                {
                  staticClass: "btn-icon rounded-circle p-3",
                  attrs: {
                    variant: "secondary",
                    size: "sm",
                    "data-cy": "actions"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onOptionDetailReceipt(_vm.receipt)
                    }
                  }
                },
                [_c("feather-icon", { attrs: { icon: "SearchIcon" } })],
                1
              )
            ],
            1
          ),
          _vm._t(
            "action-list",
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Desplegar acciones",
                      expression: "'Desplegar acciones'"
                    }
                  ]
                },
                [
                  _c(
                    "b-dropdown",
                    {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED201",
                          expression: "'ED201'"
                        }
                      ],
                      attrs: {
                        "data-cy": "gear-button",
                        variant: "link",
                        "no-caret": "",
                        right: ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "button-content",
                          fn: function() {
                            return [
                              _c("feather-icon", {
                                staticClass: "align-middle text-body",
                                attrs: {
                                  width: "24px",
                                  height: "24px",
                                  icon: "SettingsIcon"
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "binnacle" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionReceiptBinnacle(_vm.receipt)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "list" } }),
                          _vm._v(" Bitácora ")
                        ],
                        1
                      ),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED182" } },
                        [
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "visualize" },
                              on: {
                                click: function($event) {
                                  return _vm.onOptionVisualizeReceipt(
                                    _vm.receipt
                                  )
                                }
                              }
                            },
                            [
                              _c("vs-icon", { attrs: { icon: "search" } }),
                              _vm._v(" Ver comprobante ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED182" } },
                        [
                          _vm.receipt.estado ===
                          _vm.receiptsCodeStates.facturado
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "data-cy": "visualize-invoice" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onOptionVisualizeInvoice(
                                        _vm.receipt
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("vs-icon", { attrs: { icon: "search" } }),
                                  _vm._v(" Ver factura ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED183" } },
                        [
                          _vm.receipt.estado === _vm.receiptsCodeStates.emitido
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "data-cy": "invoice" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onOptionInvoiceReceipt(
                                        _vm.receipt
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("vs-icon", {
                                    attrs: { icon: "description" }
                                  }),
                                  _vm._v(" Facturar ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED228" } },
                        [
                          _vm.canCancelReceipt
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "data-cy": "cancel" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onOptionCancelReceipt(
                                        _vm.receipt
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("vs-icon", { attrs: { icon: "cancel" } }),
                                  _vm._v(" Anular ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("span")
                ],
                1
              )
            ],
            { receipt: _vm.receipt }
          )
        ],
        2
      ),
      _c(
        "b-modal",
        {
          ref: "receipt-detail-" + _vm.receipt.comprobanteId,
          attrs: {
            id: "receipt-detail-" + _vm.receipt.comprobanteId,
            title: "Detalles del comprobante Nº " + _vm.receipt.folio,
            "no-close-on-backdrop": "",
            size: "lg",
            "hide-footer": ""
          }
        },
        [_c("DetailReceipt", { attrs: { receipt: _vm.receipt } })],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "receipt-cancel-" + _vm.receipt.comprobanteId,
          attrs: {
            id: "receipt-cancel-" + _vm.receipt.comprobanteId,
            title: "Anular Comprobante N° " + _vm.receipt.folio,
            "hide-footer": ""
          }
        },
        [
          _c("ReceiptCancel", {
            attrs: { receipt: _vm.receipt },
            on: { cancel: _vm.handleOnCancel }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "invoice-receipt-" + _vm.receipt.comprobanteId,
          attrs: {
            id: "invoice-receipt-" + _vm.receipt.comprobanteId,
            title: "Facturar comprobante Nº " + _vm.receipt.folio,
            "no-close-on-backdrop": "",
            size: "sm",
            "hide-footer": ""
          }
        },
        [
          _c(
            "b-overlay",
            { attrs: { show: _vm.loadingReceipt } },
            [
              _c(
                "b-form",
                { attrs: { "data-vv-scope": "invoice-form" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Fecha de emisión (*)" } },
                    [
                      _c("date-picker", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          name: "issueDate",
                          format: "DD MMM YYYY",
                          "value-type": "YYYY-MM-DD",
                          type: "date",
                          "data-vv-as": "fecha de emisión",
                          placeholder: "Fecha de emisión",
                          "data-cy": "issue-date-invoice"
                        },
                        model: {
                          value: _vm.invoice.issueDate,
                          callback: function($$v) {
                            _vm.$set(_vm.invoice, "issueDate", $$v)
                          },
                          expression: "invoice.issueDate"
                        }
                      }),
                      _vm.errors.has("invoice-form.issueDate")
                        ? _c("div", [
                            _c("small", { staticClass: "text-danger" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.errors.first("invoice-form.issueDate")
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "text-right mt-3" },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(255, 255, 255, 0.15)",
                          expression: "'rgba(255, 255, 255, 0.15)'",
                          modifiers: { "400": true }
                        }
                      ],
                      staticClass: "mr-2",
                      attrs: {
                        "data-cy": "invoice-receipt",
                        variant: "secondary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.invoiceReceipt(true)
                        }
                      }
                    },
                    [_vm._v(" Previsualizar ")]
                  ),
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(255, 255, 255, 0.15)",
                          expression: "'rgba(255, 255, 255, 0.15)'",
                          modifiers: { "400": true }
                        }
                      ],
                      attrs: {
                        "data-cy": "invoice-receipt",
                        variant: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.invoiceReceipt(false)
                        }
                      }
                    },
                    [_vm._v(" Facturar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("ModalBinnacle", {
        ref: "binnacle-" + _vm.receipt.comprobanteId,
        attrs: {
          title: "Bitácora del Comprobante Nº " + _vm.receipt.folio,
          id: "binnacle-" + _vm.receipt.comprobanteId
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }